module.exports = __webpack_public_path__ + "static/media/classic_dream_03.6cd4b3f8.png";